/**
 * "HH:mm" formatdagi vaqtni qaytaradi.
 * Agar ISO string kelsa, local vaqtni oladi.
 * Agar allaqachon "HH:mm" formatida bo'lsa, o'zgarishsiz qaytaradi.
 */
export function formatTime(timeStr: string): string {
  // Agar allaqachon HH:mm formatida (masalan, "10:30")
  if (/^\d{2}:\d{2}$/.test(timeStr)) {
    return timeStr;
  }
  // ISO string uchun
  const date = new Date(timeStr);
  return date.toLocaleTimeString('uz-UZ', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
